<template>
    <div class="bi-com bi-input">
        <label class="bi-lbl"
            :for="id">{{label}}</label>
        <div class="bi-wrapper">
            <input type="tel"
                :id="id"
                class="bi-ib"
                :class="{'bi-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                :maxlength="maxLength"
                v-model="content"
                @input="onChange()" />
            <span class="bi-placeholder"
                :class="{'bi-placeholder-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                v-show="!content">{{placeholder}}</span>
        </div>
        <div class="bi-lbl-error"
            v-if="isShowErrorLbl"
            v-show="!isFirstSave && !errorInfo.isValid">{{errorInfo.msg}}</div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {object} errorInfo (required) Validation status.
 * @property {string} delimeter (optional) Character seperate number.
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: "ContactNumber",
    props: {
        //v-model
        value: String,
        //propss
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        delimeter: String
    },
    data: function() {
        return {
            id: '',
            label: '',
            placeholder: '',
            content: this.value,
            minLength: 0,
            maxLength: 0
        };
    },
    mounted: function() {
        this.id = this.inputId;
        this.label = this.inputLbl.name || 'Label';
        this.placeholder = this.inputLbl.placeholder || 'Placeholder';
        this.minLength = this.inputMinLength || null;
        this.maxLength = Util.isEmptyStr(this.delimeter) ? 10 : 12;
        this.validateInput();
    },
    methods: {
        validateInput: function () {
             if(!this.inputLbl) return;
             //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required
                && !this.content) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if(this.inputLbl.too_short
                && this.content < this.maxLength) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(this.inputLbl.too_short, this.maxLength);
                return;
            }
            //InValid format
            if(this.inputLbl.invalid) {
                var contactnumber = this.content.replace(this.delimeter,'');
                if(!Vue.validator.validateContactNumber(contactnumber)) {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.invalid;
                    return;
                }
            }
        },
        onChange: function() {
            var input = this.content;
            input = input.replace(Vue.RegExp.emoji, '');
            input = input.replace(Vue.RegExp.notNumber, '');

            this.validateInput();
            if (Util.isEmptyStr(this.delimeter)) {
                this.content = input;
                this.$emit("input", input);
            } else {
                var n1, n2, n3;
                var formatted = input;
                if (input.length <= 3) {
                    // do nothing
                } else if (input.length <= 6) {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    input = n1 + this.delimeter + n2;
                } else {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    n3 = input.substr(6);
                    input = n1 + this.delimeter + n2 + this.delimeter + n3;
                }

                this.content = input;
                this.$emit("input", formatted);
            }
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/component/baseinput.scss";
</style>
